import React, { Component } from "react";
import { SOCIALS, FOCUS_AREAS } from "../../../constants";

class Myself extends Component {
  renderSocials() {
    let socials = SOCIALS.map(({ title, icon, url }) => {
      return (
        <li key={`ss ${title}`}>
          <a href={url} target="_blank">
            <span className={icon}></span>
          </a>
        </li>
      );
    });

    return socials;
  }

  renderFocusAreas() {
    let areas = FOCUS_AREAS.map(({ title, description, icon }) => {
      return (
        <div key={`fa ${title}`} className="focus-item anim_piece">
          <div className="focus-item-icon">
            <span className={`fa ${icon}`}></span>
          </div>
          <div className="focus-item-body">
            <h5 className="focus-item-title">{title}</h5>
            <p className="focus-item-desc">{description}</p>
          </div>
        </div>
      );
    });

    return areas;
  }

  render() {
    return (
      <section id="myself">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2>About</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <p className="anim_piece">
                DEVELOPER. SAAS FOUNDER. AI BUILDER. CASUAL GAMER. LIFELONG
                LEARNER.
              </p>
              <p className="anim_piece text-justify">
                I'm Fernan de Dios, a technical lead developer, consultant and
                SaaS founder with more than two decades of experience building
                web applications and digital products. My background spans
                full-stack development, product architecture, and leading
                development teams, with a strong focus on turning ideas into
                reliable, scalable, and user-friendly software.
              </p>
              <p className="anim_piece text-justify">
                As a founder, I’m particularly interested in building SaaS
                products from the ground up, from identifying real-world
                problems and designing product experiences to architecting
                backend systems, developing frontend applications, deploying
                infrastructure, and continuously improving products based on how
                people actually use them. I enjoy working across the entire
                product lifecycle and combining technical execution with product
                thinking.
              </p>
              <p className="anim_piece text-justify">
                A growing part of my work focuses on artificial intelligence and
                large language models (LLMs). I explore and integrate AI
                capabilities into applications, use AI-assisted development
                workflows extensively, and look for practical ways to apply LLMs
                to improve products, automate complex processes, and create
                entirely new user experiences.
              </p>
              <p className="anim_piece text-justify">
                Throughout my career, I’ve also led development teams across a
                variety of projects, mentoring developers, making architectural
                decisions, and helping teams deliver complex software
                successfully. My approach to leadership emphasizes
                collaboration, clear communication, knowledge sharing, and
                giving people the space and support they need to do their best
                work.
              </p>
              <p className="anim_piece text-justify">
                What continues to drive me is curiosity. I enjoy learning
                new technologies, experimenting with new product ideas, and
                tackling difficult technical problems with patience and
                persistence. Whether I’m building a SaaS product, experimenting
                with AI, leading a development effort, or learning something
                completely new, I’m always looking for ways to build better and
                keep improving.
              </p>

              <ul className="anim_piece social-list">{this.renderSocials()}</ul>
            </div>

            <div className="col-sm-6">
              <div className="focus-areas">
                <div className="focus-list mt-5">{this.renderFocusAreas()}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Myself;
